import _ from 'underscore';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import { getHotelCenterUtils } from '@bingads-webui-campaign/hotel-center-utils';
import template from './view-template.pug';
import { getBidMultiplierView } from '../single-multiplier-view/view';

export const getUserCountryMultipliersView = ({
  i18n, state, pageContext, multiplierSchema,
}) => {
  const { bidMultiplierUtils } = getHotelCenterUtils({ i18n, state });
  const { BidMultiplierView } = getBidMultiplierView({ i18n, pageContext, multiplierSchema });
  const { serializeBidMultipliers } = bidMultiplierUtils;

  /**
   * Shared view for Hotel Ads User country bid multiplier
   * @extends DeterministicView
   */
  class UserCountryMultipliersView extends DeterministicView {
    initialize() {
      const countries = state.get('userCountries');

      this.i18n = i18n;
      this.selectedCountries = [];
      this.chooseCountry = countries.length > 0 ? countries[0].Key : '';
      this.restCountries = this.getRestCountries(countries, this.selectedCountries);
      this.setState({
        selectedCountries: this.selectedCountries,
        chooseCountry: this.chooseCountry,
        restCountries: this.restCountries,
      });
    }

    get events() {
      return {
        'click .add-new-query': () => {
          if (this.model.get('isUseParent')) {
            return;
          }
          if (this.chooseCountry) {
            const chooseCountry = _.findWhere(this.restCountries, { Key: this.chooseCountry });

            this.updateUserInputs();
            this.selectedCountries.push(chooseCountry);
            this.restCountries = this.getRestCountries(this.restCountries, [chooseCountry]);
            if (this.restCountries.length > 0) {
              this.chooseCountry = this.restCountries[0].Key;
            } else {
              this.chooseCountry = '';
            }
            this.setState({
              selectedCountries: this.selectedCountries,
              restCountries: this.restCountries,
              chooseCountry: this.chooseCountry,
            });
          }
        },
        'change .form-control.country-list': ({ target }) => {
          this.chooseCountry = target.value;
          this.setState({
            chooseCountry: this.chooseCountry,
          });
        },
        'click .mulitplier-query-remove .filter-query-remove__glyphicon': ({ target }) => {
          if (this.model.get('isUseParent')) {
            return;
          }
          const removeCountry = _.findWhere(this.selectedCountries, { Key: target.title });

          this.restCountries.push(removeCountry);
          this.restCountries = _.sortBy(this.restCountries, 'Key');
          this.updateUserInputs();
          this.selectedCountries = this.getRestCountries(this.selectedCountries, [removeCountry]);
          this.setState({
            selectedCountries: this.selectedCountries,
            restCountries: this.restCountries,
          });
        },
      };
    }

    get template() {
      return template;
    }

    getSelectedCountriesMulti(bidMultipliers) {
      const countries = state.get('userCountries');

      this.selectedCountries = [];

      if (bidMultipliers) {
        _.each(_.keys(bidMultipliers), (key) => {
          const country = _.findWhere(countries, { Key: key });

          if (country) {
            this.selectedCountries.push(_.extend(country, {
              strategy: bidMultipliers[key].strategy,
              factor: bidMultipliers[key].factor,
            }));
          }
        });
      }
      this.restCountries = this.getRestCountries(countries, this.selectedCountries);
      this.chooseCountry = this.restCountries.length > 0 ? this.restCountries[0].Key : '';
      return {
        selectedCountries: this.selectedCountries,
        restCountries: this.restCountries,
        chooseCountry: this.chooseCountry,
      };
    }

    getRestCountries(countries, removeNodes) {
      let keys = _.map(removeNodes, (node) => {
        if (node) {
          return node.Key;
        }
        return '';
      });

      keys = _.difference(keys, ['']);

      return _.filter(countries, country => _.indexOf(keys, country.Key) === -1);
    }

    setState({
      selectedCountries, chooseCountry, restCountries, isUseParent,
    }) {
      if (chooseCountry) {
        this.chooseCountry = chooseCountry;
        this.model.set({ chooseCountry });
      }

      if (selectedCountries) {
        _.each(selectedCountries, (country) => {
          const bidMultiplier = new BidMultiplierView({
            text: country.Value,
            value: country.Key,
            strategy: country.strategy,
            factor: country.factor,
            type: 'userCountry',
          });

          this.setChild(`${country.Key}-bid-multiplier`, bidMultiplier);
        });
        this.selectedCountries = selectedCountries;
        this.model.set({ selectedCountries });
        this.model.trigger('change');
      }

      if (restCountries) {
        this.restCountries = restCountries;
        this.model.set({ restCountries });
      }

      if (!_.isUndefined(isUseParent)) {
        this.model.set({ isUseParent });
        _.each(this.selectedCountries, (item) => {
          this.getChild(`${item.Key}-bid-multiplier`).setState({ isUseParent });
        });
      }
      return this;
    }

    updateUserInputs() {
      _.each(this.selectedCountries, (item) => {
        item.factor = this.getChild(`${item.Key}-bid-multiplier`).getState().percentage; // eslint-disable-line
      });
    }

    getState() {
      const userCountryMultipliersState = [];

      _.each(this.selectedCountries, (item) => {
        userCountryMultipliersState.push(this.getChild(`${item.Key}-bid-multiplier`).getState());
      });

      if (_.findWhere(userCountryMultipliersState, { isValid: false })) {
        return {
          isValid: false,
          bidMultipliers: _.noop(),
        };
      }

      return {
        isValid: true,
        bidMultipliers: serializeBidMultipliers(userCountryMultipliersState),
      };
    }
  }
  return {
    UserCountryMultipliersView,
  };
};
